import { Box, Card, Button as MuiButton } from '@mui/material'
import { useState } from 'react'

import { Checkbox, FormControl, FormControlLabel, Stack, Text } from '.'

function ConfirmationModal({
  title,
  description,
  confirmText = 'Confirm',
  cancelText = 'Cancel',
  onConfirm,
  onCancel,
}) {
  const [preference, setPreference] = useState(false)

  const backdropStyles = {
    position: 'fixed',
    top: 0,
    left: 0,
    width: '100vw',
    height: '100vh',
    backgroundColor: 'rgba(0, 0, 0, 0.5)',
    display: 'flex',
    justifyContent: 'center',
    alignItems: 'center',
    zIndex: 1101,
  }

  const cardStyles = {
    backgroundColor: 'white',
    padding: 5,
    borderRadius: 1,
    zIndex: 1102,
  }

  const titleStyles = {
    color: 'black',
  }

  const descriptionStyles = {
    color: 'black',
  }

  const buttonsStyles = {
    display: 'flex',
    justifyContent: 'center',
    gap: '2rem',
  }

  return (
    <Box
      sx={backdropStyles}
      onClick={(e) => {
        if (e.target === e.currentTarget) onCancel(preference)
      }}
    >
      <Card sx={cardStyles}>
        <Stack mx={3}>
          {title && <Text.H3 style={titleStyles}>{title}</Text.H3>}
          {description && <Text.Body style={descriptionStyles}>{description}</Text.Body>}
          <FormControl>
            <FormControlLabel
              control={<Checkbox onChange={(e) => setPreference(e.target.checked)} />}
              label="Don't ask me again."
            />
          </FormControl>
        </Stack>
        <Box sx={buttonsStyles}>
          <MuiButton onClick={() => onConfirm(preference)}>{confirmText}</MuiButton>
          <MuiButton onClick={() => onCancel(preference)}>{cancelText}</MuiButton>
        </Box>
      </Card>
    </Box>
  )
}

export default ConfirmationModal
